import * as types from './types'

export default {
  [types.CLEAR_DEVICES](state) {
    state.devices = []
  },
  [types.SET_LOCATION](state, location) {
    state.business = location
  },
  [types.SET_DEVICES](state, devices) {
    state.devices = []
    for (let element of devices) {
      state.devices.push({
        value: element.Id,
        name: element.FriendlyName,
        sn: element.SerialNumber
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/location/mutations.js